import { useEffect, useRef } from 'react';

import { hashSha256 } from '#src/lib/hash-sha-256';

export const useHashedEmailDataLayer = (
  email,
  dataLayerName = 'hashedEmail'
) => {
  const aborted = useRef();
  useEffect(() => {
    aborted.current = false;
    if (!global.dataLayer || !email) return;
    (async () => {
      const hash = await hashSha256(email);

      if (!aborted.current && !dataLayer.some((el) => el?.[dataLayerName])) {
        dataLayer.push({ [dataLayerName]: hash });
      }
    })();

    return () => (aborted.current = true);
  }, [email, dataLayerName]);
};
